const {
  REGEXP_MATCH_TAG,
  REGEXP_MATCH_TAG_GLOBAL
} = require('../constants/regexp')

exports.processTags = (text, data = {}, RegExpConstructor = RegExp) => {
  return ('' + text).replace(REGEXP_MATCH_TAG_GLOBAL, tag => {
    const sections = tag
      .match(REGEXP_MATCH_TAG)
    let value = sections[2] || ''

    const field = sections[1]
    const regex = sections[3] && new RegExpConstructor(sections[3])

    // Предобработка данных
    let dataValue = data[field]
    if (typeof dataValue === 'function') {
      dataValue = dataValue()
    }
    if (dataValue === undefined) {
      dataValue = ''
    }
    dataValue = '' + dataValue

    if (field && dataValue && (!regex || regex.test(dataValue))) {
      value = dataValue
    }

    return value
  })
}
